import { getUserRole, getSubscriptionState } from '../user';
import { getUserSession } from './getUserSession';

const collectGenericInfoProperties = (user) => {
  const { sessionId, sessionCreationDate } = getUserSession();
  return {
    user_id: user.wooId,
    role: getUserRole(user.select),
    subscription_state: getSubscriptionState(user.subscriptions),
    shipping_country: user.shippingAddress.country,
    sessionId,
    sessionCreationDate,
  };
};

export default collectGenericInfoProperties;
